webpackJsonp([264828590432878],{

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e declinatie"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e declinatie"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "3e declinatie"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "rex"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "femin\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "serv\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "reg\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "em"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "span",
	              { style: { fontWeight: "bold" } },
	              "es"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "De nominativus enkelvoud in ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "rex"
	        ),
	        " heeft geen uitgang. Dat komt omdat deze vorm onregelmatig is. Om de stam te bepalen moet je de meervoudsvorm leren (of opzoeken)."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "3e decl."
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "rex"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "em"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "De nominativus enkelvoud in ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "rex"
	        ),
	        " heeft geen uitgang. Dat komt omdat deze vorm onregelmatig is. Om de stam te bepalen moet je de meervoudsvorm leren (of opzoeken)."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "3e decl."
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "rex"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "em"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "De nominativus enkelvoud in ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "rex"
	        ),
	        " heeft geen uitgang. Dat komt omdat deze vorm onregelmatig is. Om de stam te bepalen moet je de meervoudsvorm leren (of opzoeken)."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "2e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "3e decl."
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mnl./vrl."
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "rex"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomen"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "em"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomen"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "arum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "De nominativus enkelvoud in ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "rex"
	        ),
	        " en de nominativus/accusativus enkelvoud in ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "nomen"
	        ),
	        " hebben geen aparte uitgang. Dat komt omdat deze vormen onregelmatig zijn. Om de stam te bepalen moet je de meervoudsvorm leren (of opzoeken)."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "4e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "5e decl."
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "em"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ua"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "uum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "uum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "erum"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ebus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ua"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "man\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "gen\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "r\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ebus"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "3e decl."
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "rex"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "em"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "arum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "De nominativus enkelvoud in ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "rex"
	        ),
	        " heeft geen uitgang. Dat komt omdat deze vorm onregelmatig is. Om de stam te bepalen moet je de meervoudsvorm leren (of opzoeken)."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "2e decl."
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "3e decl."
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "rex"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomen"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "em"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomen"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "arum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "femin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "serv\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "don\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "reg\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "nomin\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "De nominativus enkelvoud in ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "rex"
	        ),
	        " en de nominativus/accusativus enkelvoud in ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "nomen"
	        ),
	        " hebben geen aparte uitgang. Dat komt omdat deze vormen onregelmatig zijn. Om de stam te bepalen moet je de meervoudsvorm leren (of opzoeken)."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _znw = __webpack_require__(679);
	
	var _znw2 = _interopRequireDefault(_znw);
	
	var _znw3 = __webpack_require__(680);
	
	var _znw4 = _interopRequireDefault(_znw3);
	
	var _znw5 = __webpack_require__(681);
	
	var _znw6 = _interopRequireDefault(_znw5);
	
	var _znw7 = __webpack_require__(683);
	
	var _znw8 = _interopRequireDefault(_znw7);
	
	var _znw9 = __webpack_require__(684);
	
	var _znw10 = _interopRequireDefault(_znw9);
	
	var _znw11 = __webpack_require__(682);
	
	var _znw12 = _interopRequireDefault(_znw11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "1",
	  table: _znw2.default
	}, {
	  les: "2",
	  table: _znw4.default
	}, {
	  les: "3",
	  table: _znw6.default
	}, {
	  les: "4",
	  table: _znw8.default
	}, {
	  les: "5",
	  table: _znw10.default
	}, {
	  les: "36",
	  table: _znw12.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "36",
	    data: data,
	    title: "Zelfstandig naamwoord"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-zelfstandig-naamwoord-js-7120131b8cfbe941915c.js